import { Box, Table } from '@factorialco/deprecated-design-system'
import { QuotePricingLineItemFragment } from 'generated/resources/graphql'

import AddItemButton from './AddItemButton'
import ItemRowProduct from './ItemRowProduct'
import ItemRowTimeAndMaterial from './ItemRowTimeAndMaterial'

interface BodyProps {
  standaloneItems?: QuotePricingLineItemFragment[]
  currency: string
  isDraftStatus: boolean
  isProductQuote: boolean
  onUpdateStandaloneItem?: (itemId: number, updates: Partial<QuotePricingLineItemFragment>) => void
  onAddStandaloneItem?: (itemType: 'role' | 'simple') => void
  onDeleteStandaloneItem?: (itemId: number) => void
}

const Body = ({
  standaloneItems = [],
  currency,
  isDraftStatus,
  isProductQuote,
  onUpdateStandaloneItem,
  onAddStandaloneItem,
  onDeleteStandaloneItem,
}: BodyProps) => {
  const generateItemList = (items: QuotePricingLineItemFragment[]) => {
    if (isProductQuote) {
      return items.map((item) => (
        <ItemRowProduct
          key={item.id}
          item={item}
          currency={currency}
          isDraftStatus={isDraftStatus}
          onUpdate={(updates) => onUpdateStandaloneItem?.(item.id, updates)}
          onDelete={() => onDeleteStandaloneItem?.(item.id)}
        />
      ))
    } else {
      return items.map((item) => (
        <ItemRowTimeAndMaterial
          key={item.id}
          item={item}
          currency={currency}
          isDraftStatus={isDraftStatus}
          onUpdate={(updates: Partial<QuotePricingLineItemFragment>) =>
            onUpdateStandaloneItem?.(item.id, updates)
          }
          onDelete={() => onDeleteStandaloneItem?.(item.id)}
        />
      ))
    }
  }
  return (
    <Table.Body>
      {generateItemList(standaloneItems)}
      {onAddStandaloneItem && isDraftStatus && (
        <Table.Row>
          <Table.Cell colSpan={2}>
            <Box flexDirection="row" justifyContent="flexStart">
              <AddItemButton
                isProductQuote={isProductQuote}
                onAddRole={() => onAddStandaloneItem('role')}
                onAddProduct={() => onAddStandaloneItem('simple')}
              />
            </Box>
          </Table.Cell>
          <Table.Cell colSpan={14} />
        </Table.Row>
      )}
    </Table.Body>
  )
}

export default Body
